/**
 * ITaaS Business Core — branding centralisé.
 * Les overrides tenant (logo, favicon, theme) sont appliqués via useTenant().
 */

export const APP_NAME = "ITaaS RH";
export const APP_SHORT_NAME = "ITaaS RH";
export const COMPANY_NAME = "ITaaS";
export const COPYRIGHT = `© ${new Date().getFullYear()} ${COMPANY_NAME}. Tous droits réservés.`;

export const LOGO_LIGHT = "assets/img/logo.png";
export const LOGO_DARK = "assets/img/logo.png";
export const LOGO_SMALL = "assets/img/logo-small.png";
export const FAVICON = "/favicon.png";
export const FAVICON_ICO = "/favicon.ico";

/** Préparation multi-tenant : branding surchargeable par tenant */
export interface TenantBrandingOverride {
  logo?: string;
  favicon?: string;
  theme?: TenantThemeTokens;
}

export interface TenantThemeTokens {
  primaryColor?: string;
  sidebarColor?: string;
  topbarColor?: string;
  mode?: "light" | "dark";
}

/**
 * Fusionne le branding plateforme avec les overrides tenant.
 */
export function resolveBranding(
  override?: TenantBrandingOverride | null
): {
  appName: string;
  logoLight: string;
  logoDark: string;
  logoSmall: string;
  favicon: string;
  theme: TenantThemeTokens;
} {
  const tenantLogo = override?.logo;
  return {
    appName: APP_NAME,
    logoLight: tenantLogo ?? LOGO_LIGHT,
    logoDark: tenantLogo ?? LOGO_DARK,
    logoSmall: tenantLogo ?? LOGO_SMALL,
    favicon: override?.favicon ?? FAVICON,
    theme: override?.theme ?? {},
  };
}
